import { GoogleOAuthProvider } from "@react-oauth/google";

import * as axios from "axios";
import { LinkTargetProperties } from "../../../../global/components/linkSettings/interfaces";
import { useState, useCallback, useEffect } from "react";
import { useRedirect } from "../../../../global/paywall/useRedirect";
import { getPaywallSettingsFromLocalStorage, PAYWALL_LOCAL_STORAGE_KEY } from "../../../../global/paywall/authOperations";
import { getPaywallAccessData } from "../../../../global/paywall/paywallApiUrls";
import { CustomerAccessData, PremiumPaywallSignModes } from "../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallDesktop } from "../../paywallForms/desktop/premiumPaywallDesktop";
import { PremiumPaywallMobile } from "../../paywallForms/mobile/premiumPaywallMobile";

declare const window: Window & {
    PAYWALL_GOOGLE_CLIENT_ID: string
}

const GOOGLE_CLIENT_ID = typeof window !== "undefined" && window && window.PAYWALL_GOOGLE_CLIENT_ID || " ";

interface LegalLink {
    url: string;
    target: LinkTargetProperties;
}

interface PremiumPaywallUserAuthComponentaWrapperProps {
    isMobile?: boolean;
    postLoginUrl: string;
    legalLinks: { terms: LegalLink; privacy: LegalLink };
}

const getQueryParam = (param: string): string | null => {
    if (typeof window === "undefined") return null;
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};

export const PremiumPaywallUserAuthComponentaWrapper = (props: PremiumPaywallUserAuthComponentaWrapperProps) => {
    if (RUNNING_IN_SERVER) return null;
    const [isRedirecting, setIsRedirecting] = useState(false);
    const { isMobile, postLoginUrl, legalLinks } = props;
    const mode = getQueryParam("mode") === "signUp" ? "signUp" : "signIn";



    useRedirect({ fallbackUrl: postLoginUrl, enabled: isRedirecting });

    const checkUserAccess = useCallback(async () => {
        try {
            const userDetails = getPaywallSettingsFromLocalStorage();
            if (!userDetails) return;
            const res = await axios.get(getPaywallAccessData());
            const customerData = res.data as CustomerAccessData;
            if (customerData) {
                setIsRedirecting(true);
            } else {
                typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.removePaywallDataObj === "function" && window.YitPaywall.removePaywallDataObj();
                window.location.reload();
            }
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    }, []);

    useEffect(() => {
        checkUserAccess();
        const handlePageShow = (event: PageTransitionEvent) => {
            if (event.persisted) {
                checkUserAccess(); 
            }
        };

        window.addEventListener("pageshow", handlePageShow);
        return () => window.removeEventListener("pageshow", handlePageShow);
    }, [checkUserAccess]);

    useEffect(() => {
        if (!GOOGLE_CLIENT_ID || GOOGLE_CLIENT_ID === " ") {
            console.error("GOOGLE_CLIENT_ID is undefined or empty. Please provide a valid client ID.");
        }
    }, [GOOGLE_CLIENT_ID]);

    return (
        <div className="premium-page-auth-wrapper">
            <div className="yedioth-plus-logo"></div>
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                {isMobile
                    ? <PremiumPaywallMobile setIsRedirecting={setIsRedirecting} legalLinks={legalLinks} mode={mode} />
                    : <PremiumPaywallDesktop setIsRedirecting={setIsRedirecting} legalLinks={legalLinks} mode={mode} />}
            </GoogleOAuthProvider>
        </div>
    )
}

PremiumPaywallUserAuthComponentaWrapper.siteScriptName = "PremiumPaywallUserAuthComponentaWrapper"
